import React, { Component } from 'react';
import closeIcon from './../assets/close-icon.png';
import S3Image from '../../helpers/S3Image';

class Header extends Component {
  render() {
    return (
      <div className="sc-header">
        <S3Image
          className="sc-header--img rounded-circle img-navbar img-cover"
          s3Key={this.props.imageUrl}
          alt=""
          style={{ height: 64, width: 64 }}
        />
        <div className="sc-header--team-name"> {this.props.teamName} </div>
        {/*<div className="sc-header--close-button" onClick={this.props.onClose}>*/}
        {/*<img src={closeIcon} alt="" />*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default Header;
